import { tr } from "../i18n";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
const KEY = "esaia_cookie_consent";
export default function CookieBanner() {
  const {
    lang = "en"
  } = useParams();
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    if (!localStorage.getItem(KEY)) {
      const t = setTimeout(() => setVisible(true), 900);
      return () => clearTimeout(t);
    }
  }, []);
  const choose = v => {
    localStorage.setItem(KEY, v);
    setVisible(false);
  };
  return <AnimatePresence>
      {visible && <motion.div className="fixed inset-0 z-[60] flex items-center justify-center bg-esaia-ink/40 px-4 backdrop-blur-sm" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.3
    }} data-testid="cookie-banner" role="dialog" aria-modal="true" aria-label={tr("Cookie consent")}>
          <motion.div className="w-full max-w-md border border-esaia-line bg-white p-8 shadow-2xl sm:p-10" initial={{
        opacity: 0,
        y: 40,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.97
      }} transition={{
        duration: 0.45,
        ease: [0.22, 1, 0.36, 1]
      }}>
            <img src="/logo.png" alt={tr("ESAIA")} className="h-9 w-auto" />
            <h2 className="mt-6 text-xl font-semibold tracking-tight text-esaia-ink">{tr("Your privacy at ESAIA")}{" "}</h2>
            <p className="mt-3 text-sm leading-relaxed text-esaia-muted">{tr("ESAIA uses only strictly necessary cookies to keep this website secure and your session active. We do not use advertising or tracking cookies. Read our")}{" "}
              <Link to={`/${lang}/legal/cookies`} className="font-semibold text-esaia-blue hover:underline">{tr("Cookie Policy")}{" "}</Link>
              .
            </p>
            <div className="mt-7 flex gap-3">
              <button onClick={() => choose("declined")} data-testid="cookie-decline-button" className="flex-1 border border-esaia-line px-5 py-3 text-sm font-semibold text-esaia-muted transition-colors hover:border-esaia-ink hover:text-esaia-ink">{tr("Decline")}{" "}</button>
              <button onClick={() => choose("accepted")} data-testid="cookie-accept-button" className="flex-1 bg-esaia-blue px-5 py-3 text-sm font-semibold text-white transition-colors hover:bg-esaia-dark">{tr("Accept")}{" "}</button>
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}
